import React, { useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import wordcloud from "highcharts/modules/wordcloud";
import exporting from "highcharts/modules/exporting";
import exportData from "highcharts/modules/export-data";
import fullscreen from "highcharts/modules/full-screen";

// Initialize Highcharts modules
wordcloud(Highcharts);
exporting(Highcharts);
exportData(Highcharts);
fullscreen(Highcharts);

const SessionWordCloud = ({ wordcloudData }) => {
  useEffect(() => {
    const handleResize = () => {
      Highcharts.charts.forEach((chart) => {
        if (chart) chart.reflow();
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (!wordcloudData || typeof wordcloudData !== "object") {
    return null;
  }

  // ✅ Define color scheme first
  const colorScheme = [
    "#0386e5",
    "#6610f2",
    "#6f42c1",
    "#e83e8c",
    "#dc3545",
    "#fd7e14",
    "#f8c346",
    "#28a745",
    "#20c997",
    "#17a2b8",
    "#6c757d",
    "#343a40",
    "#ff5733",
    "#c70039",
    "#900c3f",
    "#581845",
    "#1f77b4",
    "#ff6347",
    "#adff2f",
    "#ff1493",
    "#00fa9a",
    "#8a2be2",
    "#a52a2a",
    "#f4a300",
    "#008080",
    "#483d8b",
    "#e9967a",
  ];

  // ✅ Convert data to uniform weight and assign color
  const transformedData = Object.entries(wordcloudData).map(([key], index) => ({
    name: key,
    weight: 1, // uniform weight
    color: colorScheme[index % colorScheme.length],
  }));

  const titleLabel =
    Object.keys(wordcloudData).length === 1
      ? `Search Keyword (${transformedData.length})`
      : `Hashtags (${transformedData.length})`;

  const options = {
    chart: {
      type: "wordcloud",
      events: {
        load: function () {
          this.reflow();
        },
      },
    },
    credits: {
      enabled: false,
    },
    title: {
      text: titleLabel,
    },
    tooltip: {
      pointFormat:
        '<span style="color:{point.color}">●</span> <b>{point.name}</b><br/>',
      style: {
        fontSize: "16px",
      },
    },
    plotOptions: {
      wordcloud: {
        minFontSize: 30,
        maxFontSize: 70,
        rotation: {
          from: -20,
          to: 20,
          orientations: 4,
        },
        placementStrategy: "center",
        spiral: "rectangular",
        padding: 1, // tighter packing
      },
    },

    series: [
      {
        type: "wordcloud",
        data: transformedData,
        rotation: {
          from: 0,
          to: 0,
        },
        colorByPoint: true,
      },
    ],
    exporting: {
      enabled: false,
      buttons: {
        contextButton: {
          enabled: false,
        },
      },
    },
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 600,
          },
          chartOptions: {
            title: {
              style: {
                fontSize: "16px",
              },
            },
            series: [
              {
                dataLabels: {
                  style: {
                    fontSize: "10px",
                  },
                },
              },
            ],
          },
        },
      ],
    },
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default SessionWordCloud;
